export const getItemFirstImage = (item?: { itemImages: string[] }) =>
  (item?.itemImages ?? []).filter((i: any) => /\.(jpe?g|png|gif|bmp)$/i.test(i))[0] ?? '';
